import React from "react";

export default function StartUsing() {
  return (
    <>
      <div className="section-space-sm-top">
        <div className="section-space-sm-bottom">
          <div className="container">
            <div className="row g-4 justify-content-between">
              <div className="col-md-6 col-lg-7 col-xxl-6">
                <h3 className="mb-0 clr-neutral-90 animate-line-3d">
                  Start Using Zenochain
                </h3>
              </div>

              <div className="col-md-6 col-lg-5 col-xl-4">
                <div className="d-flex align-items-center gap-4 flex-wrap mb-4">
                  <div className="w-30 subtitle-flush-x subtitle-flush-x--secondary subtitle_line_2" />
                  <h6 className="mb-0 clr-secondary-key fs-18 animate-text-from-right">
                    Unboxing Modularity
                  </h6>
                </div>
                <p className="mb-0 clr-neutral-80 animate-text-from-right">
                  Zenochain  empowers decentralization with proposing the most
                  efficient modular infrastructure
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Cards Section */}
        <div
          className="creative-approach-section position-relative overflow-hidden"
          style={{ padding: '60px 0' }}
        >
          <div className="container">
            <div className="row  g-5 g-xl-4">
              {[...Array(4)].map((_, i) => (
                <div
                  key={i}
                  className="col-md-6  card-parth col-xl-3 creative-approach-section__item"
                >
                  <div
                    className="fadein_bottom_8  d-flex flex-column parth h-100 justify-content-between"
                    style={{
                      backgroundColor: '#fff',
                      padding: '30px',
                      borderRadius: '12px',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                      transition: 'all 0.3s ease',
                      height: '100%',
                      cursor: 'pointer',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow =
                        '0 8px 30px rgba(0, 0, 0, 0.08)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow =
                        '0 4px 20px rgba(0, 0, 0, 0.05)';
                    }}
                  >
                    <div className="">
                      <div className="d-inline-block mb-3">
                        <img
                          src={`assets/icon/${[
                              'get_started (1)',
                              'read_whitepaper (1)',
                              'explore_ecosystem (1)',
                              'join_community (1)',
                            ][i]
                            }.svg`}
                          alt="Icon"
                          width={50}
                          className="img-fluid"
                        />
                      </div>
                      <h6 className="mb-3 clr-neutral-90">
                        <a
                          href={[
                            '/',
                            '/',
                            '/',
                            '/',
                          ][i]}
                          target={i < 2 ? '_blank' : '_self'}
                          className="link d-inline-block clr-neutral-80"
                        >
                          {
                            [
                              'Get Started',
                              'Read Whitepaper',
                              'Explore Ecosystem',
                              'Join Community',
                            ][i]
                          }{' '}
                          <i className="bi bi-arrow-up-right"></i>
                        </a>
                      </h6>
                      <p className="mb-0 clr-neutral-80">
                        {
                          [
                            'Explore the documentation that helps understand all you need to know about Zenochain .',
                            'Read our whitepaper to find out the fundamental idea behind launching Zenochain  & why it matters.',
                            'Start using ecosystem dApps that streamlines decentralized values in finance & public applications.',
                            'Connect to our wide community which is continually expanding in the realm of decentralized finance.',
                          ][i]
                        }
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


      </div>
    </>
  );
}
